import ValidatedField from "@/validation/ValidatedField";
import ValidatedForm from "@/validation/ValidatedForm";
import Rpc from "@/Rpc"
import Car from "@/server/com/silkplm/model/healthcheck/Car";


export default class AdminLoginForm extends ValidatedForm {
    constructor() {
        super();
        this.login = new ValidatedField(this, "");
        this.password = new ValidatedField(this, "");

        this.setLabels();
    }
}